export const TEXT_H4 = "Starting at $50/hr";
export const TEXT_H5 = "Competitive Pricing for Quality Utah-based Dev Services";